import * as AntIcons from '@ant-design/icons';
import React, { ReactNode } from 'react';
import customIcons from './customIcons';

const ICON_MAP: Record<string, string> = {
  dashboard: 'DashboardOutlined',
  overview: 'DashboardOutlined',
  home: 'HomeOutlined',
  people: 'TeamOutlined',
  'employee records': 'TeamOutlined',
  user: 'UserOutlined',
  users: 'TeamOutlined',
  'user-list': 'TeamOutlined',
  employee: 'TeamOutlined',
  employees: 'TeamOutlined',
  'menu & orders': 'AppstoreOutlined',
  'menu-and-orders': 'AppstoreOutlined',
  calendar: 'CalendarOutlined',
  'company calendar': 'CalendarOutlined',
  'staffing-calendar': 'CalendarOutlined',
  requests: 'FileTextOutlined',
  'tasting events': 'FileTextOutlined',
  'tasting-events': 'FileTextOutlined',
  'testing-requests': 'FileTextOutlined',
  'special order': 'ShoppingCartOutlined',
  'special orders': 'ShoppingCartOutlined',
  'special-order': 'ShoppingCartOutlined',
  'special-orders': 'ShoppingCartOutlined',
  reports: 'LineChartOutlined',
  sales: 'LineChartOutlined',
  analytics: 'BarChartOutlined',
  voucher: 'GiftOutlined',
  vouchers: 'GiftOutlined',
  'voucher requests': 'GiftOutlined',
  setting: 'SettingOutlined',
  settings: 'SettingOutlined',
};

const ICON_STYLE: React.CSSProperties = {
  fontSize: '22px',
  width: '22px',
  height: '22px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const getMenuIcon = (iconName?: string | null, menuNameOrLabel?: string | null): ReactNode => {
  const primaryName = (iconName && iconName.trim().length > 0) ? iconName.trim() : null;
  const secondaryName = (menuNameOrLabel && menuNameOrLabel.trim().length > 0) ? menuNameOrLabel.trim() : null;

  const candidateNames = [primaryName, secondaryName].filter(Boolean) as string[];

  for (const name of candidateNames) {
    if (customIcons[name]) {
      return customIcons[name];
    }

    const DirectAntdIcon = (AntIcons as any)[name];
    if (DirectAntdIcon) {
      return <DirectAntdIcon style={ICON_STYLE} />;
    }

    const normalized = name.toLowerCase().trim();
    for (const [key, iconComponent] of Object.entries(ICON_MAP)) {
      if (normalized.includes(key) && (AntIcons as any)[iconComponent]) {
        const MappedIcon = (AntIcons as any)[iconComponent];
        return <MappedIcon style={ICON_STYLE} />;
      }
    }

    const pascalName =
      name
        .replace(/[-_](\w)/g, (_, c) => c.toUpperCase())
        .replace(/^\w/, c => c.toUpperCase()) +
      (name.toLowerCase().endsWith('outlined') ? '' : 'Outlined');

    const PascalAntdIcon = (AntIcons as any)[pascalName];
    if (PascalAntdIcon) {
      return <PascalAntdIcon style={ICON_STYLE} />;
    }
  }

  return <AntIcons.AppstoreOutlined style={ICON_STYLE} />;
};

export default getMenuIcon;
